import globals from "@/utils/globals"
import getLocale from "@/utils/locale"

const state = {
  startTrialButtonCtaHref: globals.startTrialButtonCtaHref || false,
  testCategories: {}
}

const getters = {
  startTrialButtonCtaHref: (state) => {
    const testCategories = state.testCategories || {}
    if (testCategories["webtest-20240206-bw151_growth_checkoutV2"] === "growth") {
      return `/${getLocale()}/onboarding/growth-plan`
    }

    return state.startTrialButtonCtaHref
  },
  testCategories: (state) => {
    return state.testCategories
  }
}

const mutations = {
  updateTrialButtonHref: (state, href) => {
    state.startTrialButtonCtaHref = href
  },
  updateTestCategories: (state, testCategories) => {
    state.testCategories = testCategories || {}
  }
}

const actions = {
  load: ({ commit }) => {
    commit("updateTrialButtonHref", `/${getLocale()}/onboarding/matrix`)
  },
  setAbTestVariants: ({ commit }, testCategories) => {
    commit("updateTestCategories", testCategories)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
